import { actionName } from './utils';

export const AUTH = actionName('AUTH');
export const LOGOUT = actionName('LOGOUT');
export const UPDATE_USER_DATA = actionName('UPDATE_USER_DATA');
export const SET_UBS_DOMAIN = actionName('SET_UBS_DOMAIN');
